import { configureStore } from '@reduxjs/toolkit';
import redPlusSlice from 'Container/App/slice';
import { gladosApi } from 'Container/App/api/glados';
import listener from 'Container/App/listener';
import { commerceApi } from '@vfde-sails/vvl';

export const store = configureStore({
    reducer: {
        [redPlusSlice.reducerPath]: redPlusSlice.reducer,
        [gladosApi.reducerPath]: gladosApi.reducer,
        [commerceApi.reducerPath]: commerceApi.reducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware()
        .prepend(listener.middleware) // Listener goes first because of special actions in it
        .concat(gladosApi.middleware, commerceApi.middleware),
});

/**
 * Export dispatch function
 */
export const useDispatch = () => store.dispatch;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 */
export type RootState = ReturnType<typeof store.getState>;

/**
 * Infer AppDispatch
 */
export type AppDispatch = typeof store.dispatch;
